import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { PenLine, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import MoneyInput from "@/components/MoneyInput";

const today = () => new Date().toISOString().slice(0, 10);

export const CdiManualDialog = ({ account, target, onClose, onSaved }) => {
  const [day, setDay] = useState(today());
  const [amount, setAmount] = useState(0);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (target) { setDay(target.date || today()); setAmount(target.amount || 0); } }, [target]);
  const save = async () => {
    setBusy(true);
    try { await api.post(`/finance/cdi/${account}/manual`, { date: day, amount: Number(amount || 0) }); toast.success("Rendimento atualizado"); onSaved(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erro ao salvar"); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm w-[calc(100vw-1.5rem)] sm:w-full" data-testid="cdi-manual-dialog">
        <DialogHeader><DialogTitle className="font-heading font-black text-emerald-800 flex items-center gap-2"><PenLine className="w-4 h-4" /> Rendimento real do dia</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Lance o valor que o banco mostrou. Se o dia já tiver o cálculo automático, ele é substituído.</p>
        <div className="space-y-3">
          <div><label className="block text-xs font-bold text-slate-600 mb-1">Dia</label>
            <Input type="date" max={today()} value={day} onChange={(e) => setDay(e.target.value)} className="h-10" data-testid="cdi-manual-date" /></div>
          <div><label className="block text-xs font-bold text-slate-600 mb-1">Valor rendido</label>
            <MoneyInput value={amount} onChange={setAmount} className="w-full" data-testid="cdi-manual-amount" /></div>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={onClose} className="flex-1">Cancelar</Button>
          <Button onClick={save} disabled={busy || !day} className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white font-black" data-testid="cdi-manual-save">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Salvar"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
